var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { color, space, fontSize, lineHeight, textAlign, fontWeight, } from 'styled-system';
export var Text = styled.div(fontSize, lineHeight, textAlign, fontWeight, color, space);
Text.defaultProps = {
    color: 'text',
    fontSize: 3,
    lineHeight: 3,
};
export var SmallText = styled.div(fontSize, lineHeight, textAlign, fontWeight, color, space);
SmallText.defaultProps = {
    color: 'text',
    fontSize: 2,
    lineHeight: 1,
};
export var BigHeading = styled.div(fontSize, lineHeight, textAlign, fontWeight, color, space);
BigHeading.defaultProps = {
    color: 'text',
    textAlign: 'center',
    fontSize: ['fs_24', null, 'fs_32'],
    lineHeight: ['lh_32', null, 'lh_40'],
    fontWeight: 'bold',
};
export var Heading = styled.div(fontSize, lineHeight, textAlign, fontWeight, color, space);
Heading.defaultProps = {
    color: 'text',
    fontSize: ['fs_16', null, 'fs_24'],
    lineHeight: ['lh_24', null, 'lh_32'],
    fontWeight: 'bold',
};
export var SmallHeading = styled.div(fontSize, lineHeight, textAlign, fontWeight, color, space);
SmallHeading.defaultProps = {
    color: 'text',
    fontSize: ['fs_14', null, 'fs_16'],
    lineHeight: 'lh_24',
    fontWeight: 'bold',
};
export var SliderTitle = styled.h2(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), color, fontSize, space);
SliderTitle.defaultProps = {
    color: 'text',
    fontSize: ['fs_16', 'fs_18', null, 'fs_20'],
    mt: 0,
    mb: ['sp_12', 'sp_20', 'sp_24'],
};
var templateObject_1;
